import {burgerBtn} from "./shared/burger";
import {dropdown} from "./shared/dropdown";
import {Buttons} from "./pages/formInter";
import {headerBtn} from "./widgets/header";
import {sidebar, sidebarBtnCopy, sidebarBtnSocial} from "./widgets/sidebar";
import {accordion} from "./shared/accordion";
import {animationHome} from "./animation/animation";
import {scrollTo} from "./shared/scrollTo";
import {slider} from "./shared/slider";
import {TabsDefault} from "./shared/tabs";
import scrollSpeed from "./widgets/scroll";
import preloader from "./shared/preloader";
import LinkHover from "./shared/links";


document.addEventListener("DOMContentLoaded", function (e) {
  const interviewPage = document.querySelector('.site-interview');
  const homePage = document.querySelector('.site-home');
  const homePaper = document.querySelector('.site-paper');

  preloader()

  burgerBtn()
  headerBtn()
  sidebar()
  sidebarBtnCopy()
  sidebarBtnSocial()
  accordion()

  if (homePage) {
    scrollSpeed()
    animationHome()
    scrollTo()
    LinkHover()
  }
  if (interviewPage) {
    dropdown()
    Buttons()
  }

  if (homePaper) {
    slider()
    TabsDefault()
  }

});
